import { render, staticRenderFns } from "./UserProfileHeader.vue?vue&type=template&id=1485699e&scoped=true&"
import script from "./UserProfileHeader.vue?vue&type=script&lang=js&"
export * from "./UserProfileHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1485699e",
  null
  
)

export default component.exports